export const layersTree = (state) => state.layersTree
export const temporalLayers = (state) => state.temporalLayers
export const layersLoaded = (state) => state.layersLoaded
export const permaLayers = (state) => state.permaLayers
export const permaLabels = (state) => state.permaLabels
export const permaProfile = (state) => state.permaProfile
export const mapScope = (state) => state.mapScope
export const infoLayerTree = (state) => state.infoLayerTree
export const renderedLabelsMap = (state) => state.renderedLabelsMap
export const layerFiltersMap = (state) => state.layerFiltersMap
export const currentInfoItem = (state) => state.currentInfoItem
export const infoToolLine = (state) => state.infoToolLine
export const filterInfoKey = (state) => state.filterInfoKey
export const constraintPhotosId = (state) => state.constraintPhotosId
export const widgetResizeMap = (state) => state.widgetResizeMap
export const designotron = (state) => state.designotron
export const logitron = (state) => state.logitron
export const currentEditor = (state) => state.currentEditor
export const commentState = (state) => state.commentState
export const initialised = (state) => state.initialised
export const currentCommentIssue = (state) => state.currentCommentIssue
export const commentIssues = (state) => state.commentIssues
export const linkShow = (state) => state.linkShow
export const searchShow = (state) => state.searchShow
export const profileShow = (state) => state.profileShow
export const temporalShow = (state) => state.temporalShow
export const mapSize = (state) => state.mapSize
export const printMode = (state) => state.printMode
export const printProfile = (state) => state.printProfile
export const potreeLoaded = (state) => state.potreeLoaded
export const activatedLegends = (state) => state.activatedLegends

export const showReleaseNotes = (state) => state.showReleaseNotes
export const showTour = (state) => state.showTour
export const loadingTiles = (state) => state.loadingTiles
export const layersSorted = (state) => state.layersSorted
export const qeuedLayers = (state) => state.qeuedLayers
export const scopeAOI = (state) => state.scopeAOI
export const scopeState = (state) => state.scopeState

export const hideAllWidgets = (state) => state.hideAllWidgets
export const context_coords = (state) => state.context_coords
export const context_centreline = (state) => state.context_centreline
export const context_elevation = (state) => state.context_elevation
export const flow_uls_tables = (state) => state.flow_uls_tables
export const flow_mode = (state) => state.flow_mode
export const angle3d = (state) => state.angle3d
export const camera3dPotistion = (state) => state.camera3dPotistion
export const view3dtiles = (state) => state.view3dtiles
export const loadingFlowInteraction = (state) => state.loadingFlowInteraction

export const phaseOptions = (state) => state.phaseOptions

export const profileMode = (state) => state.profileMode
export const currentMapCenter = (state) => state.currentMapCenter



// WEBPACK FOOTER //
// ./src/store/modules/map/getters.js